import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AirportService {

  url = 'https://waittime-qa.api.aero/waittime/v1/current/MIA';
  constructor(private http: HttpClient) { }

  getWaitingTimes() {
    const httpOptions = {
      headers: new HttpHeaders({
        'X-apiKey': '5d0cacea6e41416fdcde0c5c5a19d867'
      })
    };
    return this.http.get<any>(this.url, httpOptions);
  }
}
